import {Enum} from 'enumify';

class WarehouseViewTypeEnum extends Enum{}

    WarehouseViewTypeEnum.initEnum({
            PackageCheckInTimeByOperator: 'packageCheckInTimeByOperator',
            ErrorPackageCheckInsByWorker: 'errorPackageCheckInsByWorker',
            AccountWithoutReceivedPackage: 'accountWithoutReceivedPackage',
            AccountSortBySentShipments: 'accountSortBySentShipments',
            AccountSortByRevenue: 'accountSortByRevenue',
            InactiveAccountForTimePeriod: 'inactiveAccountForTimePeriod',
            ShipmentsWithCoupons: 'shipmentsWithCoupons',
            SentShipmentsByMonth: 'sentShipmentsByMonth',
        }
     );

export default WarehouseViewTypeEnum;